import { render, staticRenderFns } from "./PccOrderServicePropertiesEdit.vue?vue&type=template&id=f65c858c&scoped=true&"
import script from "./PccOrderServicePropertiesEdit.vue?vue&type=script&lang=js&"
export * from "./PccOrderServicePropertiesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f65c858c",
  null
  
)

export default component.exports